import { CSSProperties, ReactNode } from 'react'
import { User } from 'lucide-react'
import { cn } from 'utils/cn'

export interface AvatarProps {
    variant?: 'letter' | 'letterSoft' | 'icon' | 'iconSoft' | 'img'
    type?: 'accent' | 'default' | 'success' | 'warning' | 'danger'
    value?: string
    icon?: ReactNode
    src?: string
    alt?: string
    size?: number
    style?: CSSProperties
}

const softBgClasses: Record<string, string> = {
    default: 'bg-default',
    accent: 'bg-accent-soft',
    success: 'bg-success-soft',
    warning: 'bg-warning-soft',
    danger: 'bg-danger-soft',
}

const fgClasses: Record<string, string> = {
    default: 'text-default-foreground',
    accent: 'text-accent',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
}

export const Avatar = ({ variant = 'letter', type = 'default', value = '', icon, src, alt = '', size = 36, style }: AvatarProps) => {
    const isImg = variant === 'img' || src
    const isSoft = variant === 'letterSoft' || variant === 'iconSoft'
    const isIcon = variant === 'icon' || variant === 'iconSoft'

    const fontSize = Math.round(size * 0.33)
    const iconSize = Math.round(size * 0.44)

    if (isImg && src) {
        return (
            <div className="relative shrink-0 overflow-hidden rounded-full" style={{ width: size, height: size, ...style }}>
                <img src={src} alt={alt} className="block size-full object-cover" />
            </div>
        )
    }

    return (
        <div
            className={cn('relative flex shrink-0 items-center justify-center rounded-full', isSoft ? softBgClasses[type] : 'bg-default')}
            style={{ width: size, height: size, ...style }}
        >
            {isIcon ? (
                <span className={cn('flex items-center justify-center', fgClasses[type])} style={{ width: iconSize, height: iconSize }}>
                    {icon || <User size={16} strokeWidth={1.5} />}
                </span>
            ) : (
                <span className={cn('text-center font-medium leading-[1.34]', fgClasses[type])} style={{ fontSize }}>
                    {value || '?'}
                </span>
            )}
        </div>
    )
}
